// import React from 'react' // 暂时未使用
import ReactDOM from 'react-dom/client'
import { ConfigProvider } from 'react-vant'
import App from './App'
import { AppStateProvider } from './contexts/AppStateContext'
import { I18nextProvider } from 'react-i18next'
import i18n from './i18n'
import { initToastConfig } from './config/toast'
import '@unocss/reset/normalize.css'
import 'react-vant/lib/index.css'
import 'virtual:uno.css'
import './style.css'
import './config/toast.css'

// 初始化 Toast 全局配置（图标、className 等）
initToastConfig()

// react-vant 主题变量配置
// 注意：Toast 挂载到 body，需要通过 CSS 全局覆盖，themeVars 对 Toast 无效
const themeVars = {
  // 全局主题变量（非 Toast）
  // 可以添加其他组件的主题变量
  '--rv-tab-font-size': '16px',
}

ReactDOM.createRoot(document.getElementById('app')!).render(
  <ConfigProvider themeVars={themeVars}>
    <I18nextProvider i18n={i18n}>
      <AppStateProvider>
        <App />
      </AppStateProvider>
    </I18nextProvider>
  </ConfigProvider>
)